import { takeEvery } from 'redux-saga/effects';
import {
  CLOSE_SG_DIALOG,
  OPEN_SG_DIALOG,
  SUBSCRIBE_SG_DIALOG_CLOSED,
  SUBSCRIBE_SG_DIALOG_OPENED,
  UNMOUNT_DIALOG
} from '../constants/sg-dialog';

const callSubscribers = (subscribers = [], ...args) => {
  for (const index in subscribers) {
    if (subscribers[index] && typeof (subscribers[index]) === 'function') {
      subscribers[index](...args);
    }
  }
};

function* sgDialog() {
  const openDialogSubscribers = {};
  const closeDialogSubscribers = {};

  // @ts-ignore
  yield takeEvery(SUBSCRIBE_SG_DIALOG_OPENED, function* ({ id, onOpened }) {
    const subscribers = openDialogSubscribers[id] || [];
    openDialogSubscribers[id] = [...subscribers, onOpened];
  });

  // @ts-ignore
  yield takeEvery(SUBSCRIBE_SG_DIALOG_CLOSED, function* ({ id, onClosed }) {
    const subscribers = closeDialogSubscribers[id] || [];
    closeDialogSubscribers[id] = [...subscribers, onClosed];
  });

  // @ts-ignore
  yield takeEvery(UNMOUNT_DIALOG, function* ({ id }) {
    openDialogSubscribers[id] = [];
    closeDialogSubscribers[id] = [];
  });

  // @ts-ignore
  yield takeEvery(OPEN_SG_DIALOG, function* ({ id, payload }) {
    callSubscribers(openDialogSubscribers[id], payload);
  });

  // @ts-ignore
  yield takeEvery(CLOSE_SG_DIALOG, function* ({ id }) {
    callSubscribers(closeDialogSubscribers[id]);
  });
}

export default sgDialog;
